{
  "clientError": {
    "title": "An error has occurred",
    "body": {
      "line1": "It looks like there was a problem with the request. Please check if you have entered the right link, or try to reload the page in a few minutes. "
    }
  },
  "serverError": {
    "title": "Something went wrong",
    "body": {
      "line1": "It looks like there was an error with the server, and we are currently working to fix this. In the meantime, try to refresh the page or come again in a few minutes. Otherwise, get help from our customer service by reaching out to us at circs@sph.com.sg"
    }
  },
  "pageNotFound": {
    "title": "Oops! Page not found",
    "body": {
      "line1": "The page you were looking for could not be found. It may have been removed, or is temporarily unavailable. Check the URL for any errors, or try going back to the previous page."
    }
  }
}
